export const breakpointsArray: BreakpointInfo[] = [];

//import * as stuff from "./_variables.scss";

//console.log(stuff);

export class BreakpointInfo extends EventTarget {
    name: string;
    fromWidth: number;
    toWidth: number;
    mediaQueryList: MediaQueryList;
    constructor(
        name: string,
        fromWidth: number,
        toWidth: number,
        observer: CurrentBreakpointObserver
    ) {
        super();
        this.name = name;
        this.fromWidth = fromWidth;
        this.toWidth = toWidth;
        this.mediaQueryList = window.matchMedia(this.matchSelectorForCode);
        this.mediaQueryList.addEventListener("change", (event) => {
            this.dispatchEvent(
                new CustomEvent("change", { detail: event.matches })
            );
            if (event.matches) {
                this.dispatchEvent(
                    new CustomEvent("active", { detail: event.matches })
                );
                observer.dispatchEvent(
                    new CustomEvent("change", { detail: this })
                );
            } else
                this.dispatchEvent(
                    new CustomEvent("inactive", { detail: event.matches })
                );
        });
    }

    get matchSelectorForCode() {
        const ruleSets = [];
        if (this.fromWidth > 0) {
            ruleSets.push(`(min-width:${this.fromWidth}px)`);
        }
        if (this.toWidth < Infinity) {
            ruleSets.push(`(max-width:${this.toWidth}px)`);
        }
        return ruleSets.join(" and ");
    }

    get matches() {
        return this.mediaQueryList.matches;
    }

    addTo(array: BreakpointInfo[]) {
        array.push(this);
        return this;
    }

    up(size: string): boolean {
        return this.atLeast(size);
    }

    atLeast(size: string): boolean {
        return this.name === size || this.prev?.atLeast(size) == true;
    }

    get next() {
        const index = breakpointsArray.indexOf(this);
        return breakpointsArray[index + 1];
    }

    get prev() {
        const index = breakpointsArray.indexOf(this);
        return breakpointsArray[index - 1];
    }
}

class CurrentBreakpointObserver extends EventTarget {}

export const observer = new CurrentBreakpointObserver();

export { default as gridBreakpoints } from "./grid-breakpoints";
import gridBreakpoints, {
    type GridBreakpointKey,
    type GridBreakpointsMap,
} from "./grid-breakpoints";

export const breakpoints: Partial<GridBreakpointsMap<BreakpointInfo>> = {};

const breakpointKeys = Object.keys(gridBreakpoints) as GridBreakpointKey[];
for (let i = 0; i < breakpointKeys.length; i++) {
    const key = breakpointKeys[i];
    const nextKey = breakpointKeys[i + 1];

    const min = gridBreakpoints[key];
    const max = nextKey != null ? gridBreakpoints[nextKey] : Infinity;

    breakpoints[key] = new BreakpointInfo(key, min, max, observer).addTo(
        breakpointsArray
    );
}

export function getCurrentBreakpoint() {
    return breakpointsArray.find((x) => x.matches);
}
